(() => {
  'use strict';

  const mobileQuery = window.matchMedia('(max-width: 1024px)');
  const marker = 'data-jozour-wa-lifted';
  const originalBottomAttr = 'data-jozour-wa-original-bottom';
  const originalBottomPriorityAttr = 'data-jozour-wa-original-bottom-priority';
  let scheduled = false;

  const whatsappSelectors = [
    'a[href*="wa.me" i]',
    'a[href*="api.whatsapp.com" i]',
    'a[href*="web.whatsapp.com" i]',
    'a[href*="whatsapp.com/send" i]',
    'iframe[src*="whatsapp" i]',
    'iframe[src*="dondy" i]',
    'iframe[src*="social-chat" i]',
    '[id*="whatsapp" i]',
    '[class*="whatsapp" i]',
    '[aria-label*="whatsapp" i]',
    '[title*="whatsapp" i]',
    '[id*="dondy" i]',
    '[class*="dondy" i]',
    '[id*="booster" i]',
    '[class*="booster" i]',
    '[data-app*="whatsapp" i]'
  ].join(',');

  function isToolbarElement(element) {
    return Boolean(element && (element.matches('.t4s-toolbar, .t4s-toolbar-mobile') || element.closest('.t4s-toolbar, .t4s-toolbar-mobile')));
  }

  function findFixedWidgetRoot(element) {
    let node = element;

    for (let depth = 0; node && node !== document.body && depth < 12; depth += 1, node = node.parentElement) {
      if (!(node instanceof HTMLElement) || isToolbarElement(node)) continue;

      const style = window.getComputedStyle(node);
      if (style.position !== 'fixed') continue;

      const rect = node.getBoundingClientRect();
      const isVisibleSize = rect.width >= 28 && rect.height >= 28;
      const isNearViewportBottom = rect.bottom >= window.innerHeight * 0.45;

      if (isVisibleSize && isNearViewportBottom) return node;
    }

    return null;
  }

  function rememberOriginalBottom(element) {
    if (element.hasAttribute(marker)) return;

    const originalBottom = element.style.getPropertyValue('bottom');
    const originalPriority = element.style.getPropertyPriority('bottom');

    element.setAttribute(marker, 'true');
    element.setAttribute(originalBottomAttr, originalBottom || '__empty__');
    element.setAttribute(originalBottomPriorityAttr, originalPriority || '__empty__');
  }

  function restoreElement(element) {
    const originalBottom = element.getAttribute(originalBottomAttr);
    const originalPriority = element.getAttribute(originalBottomPriorityAttr);

    if (originalBottom && originalBottom !== '__empty__') {
      element.style.setProperty('bottom', originalBottom, originalPriority === '__empty__' ? '' : originalPriority);
    } else {
      element.style.removeProperty('bottom');
    }

    element.removeAttribute(marker);
    element.removeAttribute(originalBottomAttr);
    element.removeAttribute(originalBottomPriorityAttr);
  }

  function restoreAll() {
    document.querySelectorAll(`[${marker}]`).forEach(restoreElement);
  }

  function applyFix() {
    scheduled = false;

    if (!mobileQuery.matches) {
      restoreAll();
      return;
    }

    const toolbar = document.querySelector('.t4s-toolbar');
    if (!toolbar || window.getComputedStyle(toolbar).display === 'none') {
      restoreAll();
      return;
    }

    const toolbarHeight = Math.ceil(toolbar.getBoundingClientRect().height || 55);
    const targetBottom = `calc(${toolbarHeight + 14}px + env(safe-area-inset-bottom, 0px))`;
    const widgets = new Set();

    document.querySelectorAll(whatsappSelectors).forEach((candidate) => {
      const root = findFixedWidgetRoot(candidate);
      if (root) widgets.add(root);
    });

    document.querySelectorAll(`[${marker}]`).forEach((element) => {
      if (!widgets.has(element)) restoreElement(element);
    });

    widgets.forEach((widget) => {
      rememberOriginalBottom(widget);
      if (widget.style.getPropertyValue('bottom') !== targetBottom || widget.style.getPropertyPriority('bottom') !== 'important') {
        widget.style.setProperty('bottom', targetBottom, 'important');
      }
    });
  }

  function scheduleFix() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(applyFix);
  }

  function init() {
    applyFix();

    const observer = new MutationObserver(scheduleFix);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'href', 'src']
    });

    window.addEventListener('resize', scheduleFix, { passive: true });
    window.addEventListener('orientationchange', scheduleFix, { passive: true });

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', scheduleFix);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(scheduleFix);
    }

    [250, 800, 1800, 3500].forEach((delay) => window.setTimeout(scheduleFix, delay));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
